import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from '../_services/auth.service';

@Component({
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.css']
})
export class TosComponent {

  public accepted = false;

  constructor(
    private bsModalRef: BsModalRef,
    private _authService: AuthService,
    public router: Router) { }

  public accept() {
    this.accepted = true;
    this.bsModalRef.hide();
  }

  public cancel() {
    this._authService.logout()
      .subscribe(() => this.router.navigate(['/login']));
    this.bsModalRef.hide();
  }
}
